import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { AuthApi, type RecoveryRequest } from '@shared/api';

interface UseRecoveryPasswordStore {
  loading: boolean;
  error: string | null;
  success: boolean | null;
  recoverPassword: (request: RecoveryRequest, signal?: AbortSignal) => Promise<void>;
  resetErrors: () => void;
  clear: () => void;
}

export const useRecoveryPasswordStore = create<UseRecoveryPasswordStore>((set) => ({
  error: null,
  loading: false,
  success: false,

  recoverPassword: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, success: false, error: null });
      await AuthApi.recoveryPassword(request, signal);
      set({ success: true, error: null, loading: false });
    } catch (error) {
      set({ success: null, error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  resetErrors: () => set({ error: null }),

  clear: () => set({ success: false, error: null, loading: false }),
}));
